import { toast } from "react-toastify";
import { getAuth, onAuthStateChanged } from "firebase/auth";

export const apiUrl = "https://lytesnap-express-backend-r44ie5b3bq-wl.a.run.app"; 
export const imageUrl = `${apiUrl}/api/images/`;

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};

export const apiHeader = async(isFormData) => {
  const auth = getAuth();
  let token = '';
  await onAuthStateChanged(auth, (user) => {
    if (user) {
      token = user?.accessToken;
    } 
  })

  if (token !== '' && !isFormData) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
  }
  if (token !== '' && isFormData) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    };
  }
  if (token == '' && !isFormData) {
    return {
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  if (token == '' && isFormData) {
    return {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
  }
};

// export const apiHeader = (token, isFormData) => {
//   const token = '';
//   onAuthStateChanged(auth, (user) => {
//     console.log(user);
//     if (user) {
//       console.log(user?.accessToken);
//     } 
//   })
//   if (token && !isFormData) {
//     return {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//       },
//     };
//   }
//   if (token && isFormData) {
//     return {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "multipart/form-data",
//       },
//     };
//   }
//   if (!token && !isFormData) {
//     return {
//       headers: {
//         "Content-Type": "application/json",
//       },
//     };
//   }

//   if (!token && isFormData) {
//     return {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     };
//   }
// };

export const firebaseVapidObject = {
  vapidKey: "",
};

export const stripe_public_key = "";

export function fieldsValidator(params) {
  const formRegEx = /([a-z])([A-Z])/g;
  const formRegExReplacer = "$1 $2";
  // validate
  for (let key in params)
    if (params[key] === "")
      return toast.warn(
        `${key.replace(formRegEx, formRegExReplacer)} is required`
      );
}
